import Google from '../assets/google.svg';
import Microsoft from '../assets/microsoft.svg';

export const config = {
    apiURL: process.env.REACT_APP_API_URL,
    siteURL: process.env.REACT_APP_SITE_URL,
    formURL: process.env.REACT_APP_FORM_URL,
    partnerUUID: process.env.REACT_APP_PARTNER_UUID,
    debounceKey: process.env.REACT_APP_DEBOUNCE_KEY,
    hubspotPortal: process.env.REACT_APP_HUBSPOT_PORTAL_ID,
    hubspotForm: process.env.REACT_APP_HUBSPOT_FORM_ID
};

export type ProvidersType = 'google_oauth2' | 'azure_activedirectory_v2';
export const providersDic: Record<ProvidersType, any> = {
    google_oauth2: {
        title: 'Google for Work',
        icon: Google
    },
    azure_activedirectory_v2: {
        title: 'Microsoft',
        icon: Microsoft
    }
};

export type StepsType =
    | 'home'
    | 'signup'
    | 'personal'
    | 'team'
    | 'role'
    | 'invite'
    | 'solutions'
    | 'purpose';

export const stepsList = [
    'home',
    'signup',
    'personal',
    'team',
    'role',
    'invite',
    'solutions',
    'purpose'
];
